import { CollectionConfig } from "./collections";

export type ModifyCollectionProps = {
    collection: CollectionConfig,
    parentPaths: string[],
};
